import
  * as React from 'react'

import { Content } from '../../atoms/Content/index'
import { IntakeContainer } from '../../organisms/Intakes/IntakeContainer'
import { IntakeInfoBar } from '../../molecules/IntakeInfoBar'
import { MenuPage } from '../MenuPage'
import { intake2Steps } from '../../organisms/Intakes/intake2Steps'

const lang = process.env.REACT_APP_LANGUAGE === 'es' ? 'es' : 'en'

export class Intake2Page extends MenuPage {
  public get hasIntakeInfoBar() {
    return true
  }
  public renderContent() {
    return (
      <div>
        <IntakeInfoBar>
          <h1>{lang === 'es' ? 'Información de la Cirugía' : 'Surgery information'}</h1>
        </IntakeInfoBar>
        <Content>
          <IntakeContainer nextPage="/contents/19" steps={intake2Steps} />
        </Content>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Intake2Page/index.tsx